import { createTableSlice } from '../helpers';

export const tableSlice = createTableSlice({
  name: 'labellersTable',
  url: '/api/users/labellers',
  sortOrder: 'desc',
  orderBy: 'last_month_count',
});
